import axios from "axios";
import { isInIframe } from "../utils";

export const source = isInIframe() ? "iframe" : "web";

axios.defaults.headers.source = source;

export const baseURL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_BASE_URL ||
      "https://dev-dot-turismo-343120.uw.r.appspot.com"
    : "https://turismo-343120.uw.r.appspot.com";

const API = (jwt = "") =>
  axios.create({
    baseURL: `${baseURL}/api`,
    headers: jwt ? { Authorization: `Bearer ${jwt}` } : {},
  });

export const getErrorMessage = (error) => {
  if (typeof error === "string") {
    return error;
  }
  if (error?.response?.data?.error?.message) {
    return error.response.data.error.message;
  }
  return error.message;
};

const isValidUrl = (url = "") =>
  url.startsWith("http") || url.startsWith("blob");

export const getFileUrl = (url = "") => {
  if (!url) {
    return undefined;
  }
  if (isValidUrl(url)) {
    return url;
  } else {
    return `${baseURL}${url}`;
  }
};

export default API;
